export const ru = {
  nav: {
    home: 'Главная',
    courses: 'Курсы',
    about: 'О нас',
    faq: 'FAQ',
    contact: 'Контакты'
  },
  hero: {
    badge: 'Премиальное образование в сфере крипты',
    title: 'Станьте мастером',
    titleHighlight: 'криптовалют',
    subtitle: 'Обучение трейдингу и блокчейн-технологиям от практикующих экспертов индустрии',
    ctaPrimary: 'Выбрать курс',
    ctaSecondary: 'Бесплатная консультация',
    stats: {
      students: '150+ студентов',
      programs: '12+ программ',
      experience: '8 лет опыта',
      support: 'Онлайн поддержка'
    }
  },
  courses: {
    title: 'Наши курсы',
    subtitle: 'Выберите программу под ваш уровень подготовки',
    levels: {
      beginner: 'Начинающий',
      intermediate: 'Средний',
      advanced: 'Продвинутый',
      professional: 'Профессиональный',
      elite: 'Элитный',
      master: 'Мастер',
      guru: 'Гуру',
      legend: 'Легенда'
    },
    duration: 'Длительность',
    practice: 'Практики',
    certificate: 'Сертификат',
    mentorship: 'Менторство',
    community: 'Доступ к комьюнити',
    lifetime: 'Доступ навсегда',
    cta: 'Подробнее',
    buy: 'Купить курс',
    badge: 'Образовательные программы',
    headingChoose: 'Выберите',
    headingPath: 'свой путь',
    count: '{{current}} / {{total}} курсов',
    items: [
      {
        id: 10,
        name: 'Crypto Intro',
        price: 100,
        level: 'beginner',
        duration: '1 неделя',
        practice: '5 часов',
        description: 'Минимальный вход в криптовалюты. Поймёте, что такое Bitcoin и как безопасно купить первую монету.',
        fullDescription: `Crypto Intro — самый доступный старт для тех, кто только слышал о криптовалютах, но ещё не разобрался, с чего начать.

За одну неделю вы получите чёткую картину рынка без перегруза терминологией и сложных стратегий.

Что вы получите:
• Понимание, что такое криптовалюта и блокчейн
• Обзор основных монет: Bitcoin, Ethereum, USDT
• Пошаговая инструкция регистрации на бирже
• Первая покупка криптовалюты без ошибок
• Базовая защита аккаунта и кошелька

Программа курса:
1. Что такое криптовалюта — простыми словами
2. Bitcoin и Ethereum: в чём разница
3. Как выбрать биржу и пройти верификацию
4. Первая покупка: пошаговый разбор
5. Базовая безопасность: пароли, 2FA, фишинг
6. Частые ошибки новичков и как их избежать`,
        features: [
          'Краткий формат без воды',
          'Доступ к чату новичков'
        ]
      },
      {
        id: 11,
        name: 'Crypto Base',
        price: 200,
        level: 'beginner',
        duration: '10 дней',
        practice: '8 часов',
        description: 'Расширенные основы: кошельки, биржи, первые сделки и базовый анализ графиков.',
        fullDescription: `Crypto Base — следующий шаг после знакомства с рынком. Курс для тех, кто хочет уверенно работать с криптовалютами самостоятельно.

Вы не просто купите первую монету — научитесь хранить активы, читать графики и избегать типичных ловушек.

Что вы получите:
• Настройка и защита криптокошельков
• Уверенная работа с биржей Binance или Bybit
• Первые осознанные сделки
• Чтение свечных графиков и трендов
• Базовое распределение портфеля

Программа курса:
1. Типы кошельков: hot, cold, custodial
2. Работа с биржей: депозит, вывод, ордера
3. Рыночные и лимитные ордера на практике
4. Основы технического анализа: свечи и тренды
5. Стейблкоины и их роль в портфеле
6. Защита от скамов и мошенников
7. Портфель новичка: пропорции и риски
8. План действий на первый месяц`,
        features: [
          'Практические задания',
          'Разбор типичных ошибок'
        ]
      },
      {
        id: 1,
        name: 'Crypto Starter',
        price: 300,
        level: 'beginner',
        duration: '2 недели',
        practice: '10 часов',
        description: 'Ваш первый шаг в мир криптовалют. Идеально для тех, кто хочет понять основы без воды и сложной терминологии.',
        fullDescription: `Добро пожаловать в мир криптовалют! Курс Crypto Starter создан специально для тех, кто только начинает свой путь в цифровых активах.

Что вы получите:
• Полное понимание блокчейн-технологии с нуля
• Уверенная работа с криптобиржами и кошельками
• Первые сделки без страха и риска
• Защита от скамов и мошенников
• Базовый анализ рынка

Программа курса:
1. Введение в криптовалюты - история, принципы работы блокчейна
2. Типы криптовалют - Bitcoin, Ethereum, альткоины, стейблкоины
3. Как создать и защитить кошельки - аппаратные, программные, онлайн
4. Работа с биржами - Binance, Bybit, OKX пошагово
5. Первая покупка криптовалюты - от регистрации до первой монеты
6. Базовая безопасность - 2FA, сид-фразы, холодное хранение
7. Чтение графиков и свечей - основы технического анализа
8. Психология инвестора - как не продать на панике
9. Портфель новичка - базовое распределение активов
10. Кейсы успеха и ошибок - реальные истории студентов`,
        features: [
          'Разборы реальных сделок',
          'Обновления по новым трендам'
        ]
      },
      {
        id: 12,
        name: 'Spot Strategist',
        price: 400,
        level: 'intermediate',
        duration: '3 недели',
        practice: '18 часов',
        description: 'Спотовая торговля без плеча: вход по плану, управление позицией и портфель под реальный рынок.',
        fullDescription: `Spot Strategist — курс для тех, кто уже купил первую крипту и хочет торговать осознанно, без кредитного плеча и лишней суеты.

Вы научитесь строить простые стратегии на споте, считать риск на сделку и собирать портфель под свой горизонт.

Что вы получите:
• Понятный алгоритм входа и выхода на споте
• Работа с уровнями, объёмом и новостным фоном
• Правила размера позиции без переторговли
• Сборка и ребаланс портфеля
• Чек-листы перед каждой сделкой

Программа курса:
1. Спот vs фьючерсы — когда достаточно спота
2. Структура сделки: сетап, вход, стоп, фиксация
3. Уровни и зоны интереса на практике
4. Объём и ликвидность: как не покупать «в пустоту»
5. Новости и катализаторы без FOMO
6. Портфель: ядро, сателлиты, кэш в стейблкоинах
7. Дневник сделок и разбор ошибок
8. План на 30 дней после курса`,
        features: [
          'Шаблоны торговых планов',
          'Разбор спотовых сетапов'
        ]
      },
      {
        id: 2,
        name: 'Smart Trader',
        price: 500,
        level: 'intermediate',
        duration: '1 месяц',
        practice: '25 часов',
        description: 'Системный подход к торговле. Стратегии, которые закрепляются на практике, а не в теории.',
        fullDescription: `Smart Trader - это курс для тех, кто хочет освоить активную и системную торговлю криптовалютами.

Мы не продаем "грааль" - мы учим дисциплине, анализу и управлению рисками. Каждая стратегия проверена на реальном рынке.

Чему вы научитесь:
• Читать рынок как профессионал
• Использовать 5+ рабочих торговых стратегий
• Управлять капиталом и рисками
• Контролировать эмоции при торговле
• Создавать собственные торговые планы

Программа курса:
1. Технический анализ углубленно
   - Все паттерны и фигуры
   - Уровни поддержки/сопротивления
   - Трендовые каналы и линии
   - Волновой анализ (база)
   
2. Индикаторы и осцилляторы
   - RSI, MACD, Stochastic
   - Индикаторы объема
   - Настройка под разные таймфреймы
   - Комбинирование индикаторов
   
3. Свечной анализ
   - Все значимые паттерны
   - Пин-бары, поглощение, доджи
   - Свечные комбинации
   - Ложные пробои
   
4. Торговые стратегии
   - Стратегия на пробое
   - Контр-трендовая стратегия
   - Скальпинг (краткосрочный)
   - Свинг-трейдинг (среднесрочный)
   - Стратегия на новостях
   
5. Управление рисками
   - Расчет позиции
   - Стоп-лоссы и тейк-профиты
   - Соотношение риск/прибыль
   - Диверсификация
   
6. Психология трейдинга
   - Планирование сделок
   - Ведение дневника трейдера
   - Работа со страхом и жадностью
   - Восстановление после просадок`,
        features: [
          'Библиотека стратегий',
          'Индивидуальные созвоны'
        ]
      },
      {
        id: 3,
        name: 'DeFi Investor',
        price: 700,
        level: 'advanced',
        duration: '6 недель',
        practice: '40 часов',
        description: 'Погружение в децентрализованные финансы. Стейкинг, пулы ликвидности, yield farming и многое другое.',
        fullDescription: `DeFi Investor - полное погружение в мир децентрализованных финансов. Здесь вы изучите, как устроены DeFi-протоколы и как с ними работать осознанно.

DeFi — сложная и быстро меняющаяся область, которая требует глубоких знаний. Этот курс — ваша карта в мире децентрализации.

Что вы освоите:
• Работа с DeFi-протоколами на профессиональном уровне
• Анализ протоколов и оценка рисков
• Минимизация рисков (impermanent loss, хаки)
• Разработка собственных DeFi-стратегий
• Оптимизация газовых комиссий

Программа курса:
1. Основы DeFi
   - Что такое смарт-контракты
   - Как работают DEX
   - Типы токенов: ERC-20, BEP-20, и др.
   - Блокчейны для DeFi: Ethereum, BSC, Polygon, Arbitrum
   
2. Работа с DEX
   - Uniswap, PancakeSwap, 1inch
   - Свопы и маршрутизация
   - Limit orders на DEX
   - Агрегаторы ликвидности
   
3. Пулы ликвидности
   - Как работают AMM
   - Impermanent loss - расчет и защита
   - Выбор оптимальных пулов
   - Двусторонние и односторонние пулы
   
4. Стейкинг и фермерство
   - Виды стейкинга
   - Доходное фермерство (yield farming)
   - Рестейкинг через EigenLayer
   - Автокомпаундинг
   
5. Доходные стратегии
   - Стратегия "Дельта-нейтральная"
   - Арбитраж между DEX
   - Стратегия на волатильности
   - Мультичейн фермерство
   
6. Инструменты анализа
   - DeFi Llama, DeBank
   - Анализ TVL и метрик
   - Проверка аудитов контрактов
   - Отслеживание китов
   
7. Безопасность в DeFi
   - Распознавание скам-проектов
   - Ревок апрувов
   - Мультисиг кошельки
   - Страхование позиций (Nexus Mutual)
   
8. Налоги и учет
   - Отслеживание транзакций
   - Налоговая оптимизация
   - Инструменты: CoinTracker, Koinly`,
        features: [
          'Разбор новых протоколов',
          'Индивидуальная стратегия под ваш капитал',
          'Обновления по новым трендам'
        ]
      },
      {
        id: 4,
        name: 'Futures Master',
        price: 800,
        level: 'professional',
        duration: '2 месяца',
        practice: '60 часов',
        description: 'Торговля фьючерсами и маржинальная торговля. Кредитное плечо как инструмент, а не игрушка.',
        fullDescription: `Futures Master - курс для серьезных трейдеров, которые хотят освоить торговлю с плечом на профессиональном уровне.

Фьючерсы позволяют торговать в разных рыночных условиях и используют кредитное плечо — но требуют железной дисциплины.

Почему этот курс:
• Обучение на реальных сделках, а не теории
• Риск-менеджмент как главный приоритет
• Психологическая подготовка к высоким ставкам
• Автоматизация торговых процессов

Программа курса:
1. Основы фьючерсов
   - Что такое фьючерсы и перпетуал
   - Маржинальная торговля
   - Финансирование и funding rate
   - Типы ордеров: limit, market, stop
   
2. Работа с плечом
   - Изоляция vs Кросс-маржа
   - Расчет эффективного плеча
   - Управление маржин-коллом
   - Оптимальное плечо для разных стратегий
   
3. Стратегии лонг/шорт
   - Трендовые стратегии с плечом
   - Контр-тренд на фьючерсах
   - Арбитраж спот-фьючерс
   - Базисная торговля
   
4. Анализ ликвидаций
   - Карты ликвидаций
   - Ловушки ликвидности
   - Торговля против толпы
   - Индикаторы позиций толпы
   
5. Риск-менеджмент
   - Расчет позиции по формуле
   - Каскадные стопы
   - Хеджирование спотовых позиций
   - Корреляционные риски
   
6. Алгоритмизация
   - Торговые боты: основы
   - Grid-торговля
   - DCA-боты на фьючерсах
   - Арбитражные боты
   
7. Психология плеча
   - Работа с жадностью
   - Восстановление после ликвидации
   - Размер позиции и эмоции
   - Торговый план под плечо`,
        features: [
          'Торговые сигналы',
          'Приоритетная поддержка'
        ]
      },
      {
        id: 5,
        name: 'Whale Analyst',
        price: 1000,
        level: 'elite',
        duration: '3 месяца',
        practice: '80 часов',
        description: 'Глубокий ончейн-анализ. Отслеживание умных денег, аналитика китов, предиктивные модели.',
        fullDescription: `Whale Analyst - курс для тех, кто хочет видеть рынок насквозь. Ончейн-аналитика позволяет следовать за умными деньгами и предугадывать движения рынка.

Вы будете использовать те же инструменты, что и крупнейшие фонды и киты криптоиндустрии.

Что входит в программу:
• Полный ончейн-анализ с нуля до профи
• Работа с Glassnode, Nansen, Arkham
• Отслеживание кошельков китов
• Создание предиктивных моделей
• Анализ макроиндикаторов

Детальная программа:
1. Блокчейн-исследователи
   - Etherscan, BscScan, Solscan
   - Чтение транзакций
   - Анализ смарт-контрактов
   - Отслеживание потоков
   
2. Платформы ончейн-аналитики
   - Glassnode: все метрики
   - CryptoQuant: профессиональная работа
   - Nansen: смарт-мани
   - Arkham: раскрытие кошельков
   - Santiment: поведенческий анализ
   
3. Метрики и индикаторы
   - MVRV, NUPL, SOPR
   - Анализ обменных резервов
   - Долгосрочные держатели
   - Майнерские потоки
   - Стейкинговые оттоки
   
4. Анализ китов
   - Идентификация крупных игроков
   - Отслеживание кошельков
   - Корреляция с ценой
   - Smart Money Concepts
   
5. Социальный анализ
   - Сантимент в соцсетях
   - Аналитика Twitter/Discord
   - Страх и жадность
   - Трендовые слова и хэштеги
   
6. Макроанализ
   - Корреляция с традиционным рынком
   - Данные ФРС и инфляции
   - ETF-потоки
   - Геополитические факторы
   
7. Практическое применение
   - Создание дашбордов
   - Автоматические алерты
   - Отчеты для инвесторов
   - Интеграция с TradingView`,
        features: [
          'Шаблоны анализа',
          'Инсайдерская информация',
          'Ранний доступ к разборам'
        ]
      },
      {
        id: 6,
        name: 'Altcoin Hunter',
        price: 1500,
        level: 'master',
        duration: '4 месяца',
        practice: '100 часов',
        description: 'Поиск перспективных альткоинов до их взлета. Фундаментальный анализ, токеномика, вестинг.',
        fullDescription: `Altcoin Hunter - курс для охотников за жемчужинами крипторынка. Научитесь находить проекты до того, как о них узнает толпа.

Мы раскрываем методологию поиска альфы, которую используют криптофонды с миллиардными капитализациями.

Что вы узнаете:
• Фундаментальный анализ криптоактивов
• Оценка токеномики и вестинга
• Анализ команды и инвесторов
• Ранний доступ к IDO/IEO/ICO
• Диверсификация альткоин-портфеля

Детальная программа:
1. Фундаментальный анализ
   - Whitepaper: что искать
   - Оценка технологии
   - Конкурентный анализ
   - Product-market fit
   
2. Токеномика
   - Распределение токенов
   - Вестинг и анлоки
   - Инфляция и дефляция
   - Utility токена
   - Токеномические модели
   
3. Команда и инвесторы
   - Due diligence команды
   - Верификация экспертизы
   - Анализ инвесторов (VC)
   - Advisory board
   - Партнерства
   
4. Метрики проекта
   - TVL и его динамика
   - Активность разработки (GitHub)
   - Социальные метрики
   - Ончейн-активность
   - Сравнительный анализ
   
5. Ранние проекты
   - IDO платформы
   - IEO на биржах
   - Seed и Private раунды
   - Стратегия участия
   - Whitelist стратегии
   
6. Секторы крипты
   - L1 и L2 решения
   - DeFi 2.0 и 3.0
   - GameFi и метавселенные
   - RWA (реальные активы)
   - AI и крипта
   - Мемкоины как индикатор
   
7. Портфельное управление
   - Балансировка по секторам
   - Стадии роста проектов
   - Фиксация прибыли
   - Ребалансировка
   
8. Риск-анализ
   - Регуляторные риски
   - Технические риски
   - Риски команды
   - Рыночные риски`,
        features: [
          'Шаблоны анализа',
          'Инсайдерская информация',
          'Ранний доступ к разборам'
        ]
      },
      {
        id: 7,
        name: 'NFT & Metaverse Pro',
        price: 2000,
        level: 'guru',
        duration: '5 месяцев',
        practice: '120 часов',
        description: 'Мир NFT, метавселенных и GameFi. Коллекционирование, флиппинг, создание коллекций, P2E игры.',
        fullDescription: `NFT & Metaverse Pro - полное погружение в мир невзаимозаменяемых токенов, метавселенных и блокчейн-игр.

Это не просто картинки обезьян — это новая экономика цифровой собственности с собственными правилами и инструментами.

Что вы освоите:
• Профессиональный трейдинг NFT
• Создание успешных коллекций
• Работа с метавселенными
• GameFi и P2E стратегии
• Владение цифровой недвижимостью

Детальная программа:
1. Мир NFT
   - Технология NFT глубоко
   - Стандарты: ERC-721, ERC-1155, и др.
   - Рынки: OpenSea, Blur, Magic Eden
   - История и эволюция NFT
   
2. Трейдинг NFT
   - Флиппинг стратегии
   - Анализ редкости и свойств
   - Тренды и мемы
   - Работа с гасом (gas wars)
   - Снайпинг редких NFT
   
3. Коллекционирование
   - Blue chip коллекции
   - Оценка долгосрочной ценности
   - Utility и права
   - IP и коммерческое использование
   
4. Создание коллекций
   - Генерация арта
   - Smart contracts для NFT
   - Launch стратегии
   - Маркетинг коллекции
   - Создание комьюнити
   
5. Метавселенные
   - Decentraland, Sandbox, Otherside
   - Покупка и развитие земель
   - Монетизация метавселенных
   - Ивенты и бизнес в метавселенных
   
6. GameFi
   - Экономика блокчейн-игр
   - P2E модели
   - Топовые игры и стратегии
   - Изучение игровых токенов
   - Гильдии и стипендии
   
7. Инструменты
   - NFT аналитика
   - Отслеживание китов
   - Rarity.tools и аналоги
   - Автоматизация покупок
   
8. Правовые аспекты
   - Авторские права на NFT
   - Налоги на NFT
   - Контракты и соглашения`,
        features: [
          'Инсайдерская аналитика',
          'Особый статус в комьюнити'
        ]
      },
      {
        id: 8,
        name: 'Crypto Empire',
        price: 2500,
        level: 'legend',
        duration: '6 месяцев',
        practice: '150 часов',
        description: 'Комплексная программа создания криптоимперии. Все направления, автоматизация, команда, масштабирование.',
        fullDescription: `Crypto Empire — комплексная программа для тех, кто хочет освоить криптоиндустрию на профессиональном уровне.

Здесь вы изучите все ключевые направления: трейдинг, DeFi, NFT, создание контента и консалтинг.

Это программа для тех, кто хочет:
• Выстроить системный подход к работе с криптоактивами
• Освоить управление капиталом и рисками
• Построить команду и автоматизировать процессы
• Стать авторитетом в криптоиндустрии

Программа включает ВСЕ предыдущие курсы плюс эксклюзивный модуль:

1. Мастер-программа (все курсы платформы)
2. Эксклюзивный модуль Crypto Empire:

   Блок 1: Капитал-менеджмент
   - Управление 8-9 значными суммами
   - Структурирование активов
   - Оффшорное планирование
   - Наследование криптоактивов
   
   Блок 2: Создание рабочих систем
   - Построение майнинг-ферм
   - Ноды и валидаторы
   - Крипто-бизнес под ключ
   - Создание фонда/DAO
   
   Блок 3: Автоматизация
   - Торговые алгоритмы
   - Автоматические стратегии DeFi
   - Боты для всех направлений
   - Интеграция с API бирж
   
   Блок 4: Командное управление
   - Найм аналитиков и трейдеров
   - Делегирование задач
   - Создание системы управления
   - Масштабирование операций
   
   Блок 5: Личный бренд
   - Позиционирование эксперта
   - Контент-стратегия
   - Рост аудитории
   - Монетизация влияния
   
   Блок 6: Нетворкинг
   - Закрытые мероприятия
   - Связи с фондами
   - Инсайдерская информация
   - Стратегические партнерства
   
   Блок 7: Будущее крипты
   - Регуляторная эволюция
   - Институциональное принятие
   - Новые технологии (ZK, L3)
   - Подготовка к бычьему рынку

Особые условия:
• Персональная встреча с основателем
• Еженедельные созвоны 1 на 1
• Доступ ко всем закрытым каналам
• Приоритет в любых проектах
• Сопровождение 12 месяцев`,
        features: [
          'ВСЕ курсы + эксклюзив',
          'Приоритет навсегда'
        ]
      },
      {
        id: 9,
        name: 'VIP Mentorship',
        price: 3000,
        level: 'legend',
        duration: '12 месяцев',
        practice: 'Безлимит',
        description: 'Персональное менторство от основателя RedLevelCrypto. Полное сопровождение, приватные встречи, инсайды.',
        fullDescription: `VIP Mentorship - эксклюзивная программа личного сопровождения от основателя RedLevelCrypto.

Это не курс в обычном понимании. Это полноценное партнерство, где вы получаете прямой доступ к мышлению и стратегиям топ-уровня.

Только 10 мест в год.

Что включено:
• Еженедельные личные созвоны
• Доступ к закрытым сделкам
• Совместное принятие решений
• Помощь в кризисных ситуациях
• Нетворкинг на высшем уровне

Формат:
1. Стратегические сессии (2 часа/неделю)
   - Разбор вашего портфеля
   - Планирование действий
   - Корректировка стратегии
   - Психологическая поддержка
   
2. Оперативная связь
   - Telegram/WhatsApp 24/7
   - Ответ в течение часа
   - Экстренные консультации
   - Голосовые разборы
   
3. Эксклюзивный доступ
   - Доступ к приватным сейлам
   - Ранний доступ к информации
   - Встречи с основателями проектов
   - Участие в закрытых раундах
   
4. Мероприятия
   - Личные встречи quarterly
   - Доступ к VIP-ивентам
   - Конференции и саммиты
   - Закрытые вечеринки
   
5. Ресурсы
   - Полный доступ ко всем материалам
   - Индивидуальные исследования
   - Персональные инструменты
   - Приоритет в новых направлениях

Результат:
Углублённое понимание рынка и выработка собственной системы принятия решений.

Требования к кандидатам:
• Готовность к интенсивной работе
• Минимальный капитал $100k+
• Чистая репутация в индустрии
• Долгосрочное мышление

Интервью перед началом обязательно.`,
        features: [
          'Все ресурсы платформы',
          'Максимальный приоритет'
        ]
      }
    ]
  },
  features: {
    title: 'Почему выбирают нас',
    items: [
      {
        title: 'Практические навыки',
        description: 'Программы построены на реальных кейсах и практических заданиях, а не на абстрактной теории.',
        icon: 'TrendingUp'
      },
      {
        title: 'Топовые эксперты',
        description: 'Обучение ведут практикующие трейдеры с 2+ годами опыта работы на рынке.',
        icon: 'Users'
      },
      {
        title: 'Актуальные знания',
        description: 'Курсы обновляются ежемесячно. Вы всегда получаете самую свежую информацию о рынке.',
        icon: 'RefreshCw'
      },
      {
        title: 'Комьюнити',
        description: 'Чат в Telegram с единомышленниками и инсайдерской информацией.',
        icon: 'MessageCircle'
      },
      {
        title: 'Практика',
        description: 'Более 70% времени — практические задания и разборы рынка, не сухая теория.',
        icon: 'Target'
      },
      {
        title: 'Онлайн поддержка',
        description: 'Наши кураторы отвечают на вопросы в любое время дня и ночи.',
        icon: 'Headphones'
      }
    ]
  },
  about: {
    title: 'О RedLevelCrypto',
    subtitle: 'Мы находимся в Республике Беларусь',
    description: `RedLevelCrypto — премиальная образовательная платформа для изучения криптовалют, трейдинга и блокчейн-технологий.

Мы находимся в Республике Беларусь. В РБ криптовалюты полностью легализованы — вы можете свободно покупать, продавать, хранить и использовать цифровые активы в рамках действующего законодательства.

Наша миссия — дать студентам практические знания и навыки для работы с крипторынком. Мы не обещаем быстрых результатов и не продаём «секретные стратегии». Мы учим анализировать, думать и принимать взвешенные решения.

С 2024 года мы обучили более 150 студентов. Наши выпускники работают в топовых криптофондах, управляют собственными фондами или торгуют на собственный капитал.

Что нас отличает:
• Только практикующие преподаватели
• Обновляемые материалы
• Живая поддержка
• Реальные результаты
• Комьюнити профессионалов`,
    stats: [
      { value: '150+', label: 'Выпускников' },
      { value: '12+', label: 'Образовательных программ' },
      { value: '2', label: 'Года на рынке' },
      { value: 'РБ', label: 'Легальный бизнес' }
    ]
  },
  faq: {
    title: 'Частые вопросы',
    items: [
      {
        question: 'С какого курса начать новичку?',
        answer: 'Для абсолютных новичков с минимальным бюджетом рекомендуем Crypto Intro ($100) или Crypto Base ($200). Для полноценного старта — Crypto Starter ($300). Если у вас уже есть базовые знания и вы хотите сразу торговать — Smart Trader ($500).'
      },
      {
        question: 'Есть ли рассрочка или скидки?',
        answer: 'Нет, мы не предоставляем рассрочку. Оплата доступна любой картой мира.'
      },
      {
        question: 'Как долго доступен курс после покупки?',
        answer: 'Все курсы предоставляются с пожизненным доступом, включая все будущие обновления. VIP Mentorship имеет ограниченный срок действия (12 месяцев).'
      },
      {
        question: 'Нужен ли большой стартовый капитал?',
        answer: 'Нет, многие наши студенты начинали с $100-500. Главное - знания и дисциплина. Конечно, чем больше капитал, тем быстрее масштабирование.'
      },
      {
        question: 'Есть ли поддержка после курса?',
        answer: 'Да, доступ в закрытые комьюнити сохраняется навсегда. Также для выпускников есть специальные каналы с аналитикой и разборами рынка.'
      }
    ]
  },
  courseDetail: {
    notFound: 'Курс не найден',
    backHome: 'Вернуться на главную',
    allCourses: 'Все курсы',
    specs: 'Характеристики курса',
    description: 'Описание курса',
    includes: 'Что включено',
    features: 'Возможности',
    readyTitle: 'Готовы начать обучение?',
    readySubtitle: 'Присоединяйтесь к {{name}} и начните структурированное обучение',
    buyFor: 'Купить курс за ${{price}}',
    paymentNote: 'Оплата доступна любой картой мира',
    paymentBadge: 'Оплата любой картой мира'
  },
  telegramModal: {
    title: 'Присоединяйтесь к нам',
    description:
      'Для покупки курса и получения консультации напишите нам в Telegram. Наши менеджеры ответят вам в течение 15 минут.',
    cta: 'Написать в Telegram',
    emailNote: 'Или напишите нам на почту: redlevelsupport@icloud.com'
  },
  buyModal: {
    title: 'Покупка курса',
    text: 'Для покупки курса напишите нам на почту или в Telegram — либо оставьте заявку на обратную связь.',
    writeTelegram: 'Написать в Telegram',
    writeEmail: 'Написать на почту',
    callback: 'Оставить заявку на обратную связь',
    takeTest: 'Не уверены в выборе? Тогда пройдите бесплатный тест',
    close: 'Закрыть'
  },
  contactForm: {
    title: 'Подберём курс под вас',
    subtitle: 'Оставьте имя и пройдите короткий тест — мы предложим программу под ваш бюджет.',
    callbackTitle: 'Заявка на обратную связь',
    callbackSubtitle: 'Оставьте контакты — мы свяжемся и поможем с покупкой курса.',
    nameLabel: 'Имя',
    namePlaceholder: 'Как к вам обращаться?',
    emailLabel: 'Email',
    emailPlaceholder: 'you@email.com',
    telegramLabel: 'Telegram',
    telegramPlaceholder: '@username',
    required: 'Обязательное поле',
    invalidEmail: 'Введите корректный email',
    invalidTelegram: 'Укажите Telegram в формате @username',
    startQuiz: 'Пройти тест',
    next: 'Далее',
    back: 'Назад',
    submit: 'Отправить заявку',
    submitting: 'Отправка...',
    successTitle: 'Заявка отправлена',
    successText: 'Мы свяжемся с вами в ближайшее время и подтвердим курс.',
    error: 'Не удалось отправить. Попробуйте ещё раз или напишите нам напрямую.',
    matchTitle: 'Курс подобран под ваш бюджет',
    matchSubtitle: 'Оставьте контакты — менеджер свяжется и поможет оформить выбранную программу.',
    recommendedLabel: 'Рекомендуем вам',
    recommendedPrice: '${{price}}',
    quizIntro: '5 коротких вопросов',
    questionOf: 'Вопрос {{current}} из {{total}}',
    writeTelegram: 'Написать в Telegram',
    writeEmail: 'Написать на почту',
    orDirect: 'Или свяжитесь напрямую',
    close: 'Закрыть',
    questions: [
      {
        q: 'Какой у вас опыт в криптовалютах?',
        options: [
          'Только начинаю',
          'Есть базовые знания',
          'Торгую самостоятельно',
          'Профессиональный уровень'
        ]
      },
      {
        q: 'Какая у вас главная цель?',
        options: [
          'Понять основы рынка',
          'Научиться системно торговать',
          'Инвестировать долгосрочно',
          'Персональное менторство'
        ]
      },
      {
        q: 'Сколько времени готовы уделять обучению в неделю?',
        options: ['2–4 часа', '5–10 часов', '10–20 часов', 'Максимум возможного']
      },
      {
        q: 'Какой бюджет на курс рассматриваете?',
        options: [
          'До $200',
          '$300–$400',
          '$500–$700',
          '$800–$1000',
          '$1500–$2000',
          '$2500+'
        ]
      },
      {
        q: 'Что вам интереснее всего?',
        options: [
          'Спотовая торговля',
          'Фьючерсы и плечо',
          'DeFi и инвестиции',
          'Полное сопровождение'
        ]
      }
    ]
  },
  promo: {
    code: 'SALE50',
    discount: '50',
    welcomeTitle: 'Скидка новым пользователям',
    welcomeText: 'На первую покупку любого курса — скидка $50 по промокоду SALE50.',
    copy: 'Скопировать',
    copied: 'Скопировано',
    close: 'Закрыть',
    stickyText: '−$50 на первый курс',
    stickyCode: 'SALE50'
  },
  cta: {
    title: 'Готовы начать обучение?',
    subtitle: 'Присоединяйтесь к 150+ студентам RedLevelCrypto',
    button: 'Начать обучение'
  },
  footer: {
    description: 'Премиальное образование в сфере криптовалют, трейдинга и блокчейн-технологий.',
    legal: 'Юридическая информация',
    links: {
      courses: 'Курсы',
      about: 'О нас',
      faq: 'FAQ',
      contact: 'Контакты',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования'
    },
    contact: {
      email: 'redlevelsupport@icloud.com',
      telegram: '@RedLevelCrypto',
      support: 'Онлайн поддержка'
    },
    rights: '© 2024-2026 RedLevelCrypto. Все права защищены.',
    operator: {
      name: 'Новик Беата Сергеевна',
      taxId: 'УНП: НЕ7424414',
      address:
        'Адрес регистрации: Республика Беларусь, Гродненская обл., Ошмянский р-н, г. Ошмяны, ул. МИЦКЕВИЧА, д. 51'
    }
  },
  buyMonecle: {
    badge: 'Оплата',
    title: 'Оплата курса',
    subtitle: 'Выберите валюту и сумму. Вы перейдёте на защищённую страницу оплаты Monecle.',
    currency: 'Валюта оплаты',
    usd: 'USD $',
    eur: 'EUR €',
    pay: 'Оплатить',
    secure: 'Безопасная оплата картой через Monecle',
    backHome: 'На главную',
    fallbackName: 'Курс'
  }
};
